<script lang="ts">
  import { cn } from "@tastyworks/ui-library"
  import type { Snippet } from "svelte"

  type Props = {
    alignActions?: "start" | "center" | "end"
    class?: string
    children?: Snippet
  }

  let {
    alignActions = "end",
    class: className,
    children,
    ...restProps
  }: Props = $props()
</script>

<div
  class={cn(
    "mobile:flex-col-reverse flex w-full gap-2 max-sm:flex-col-reverse",
    className
  )}
  class:justify-start={alignActions === "start"}
  class:justify-center={alignActions === "center"}
  class:justify-end={alignActions === "end"}
  {...restProps}
>
  {@render children?.()}
</div>
